<div class="grid-x">
  <div class="cell">
    <label>
      <span class="label-text">
        Button Label:
      </span>
      <input type="text" id="text" [(ngModel)]="componentData.config.text"/>
    </label>
  </div>
</div>
<div class="grid-x">
  <div class="cell auto">
    <label>
      <span class="label-text bold">
        Display Results as:
      </span>
    </label>
  </div>
</div>
<div class="grid-x">
  <div class="cell">
    <input type="checkbox" name="onInit" [(ngModel)]="componentData.config.runOnInit" /> Run Query Without Button click
  </div>
</div>
<div class="grid-x">
  <div class="cell">
    @for (opt of displayOptions; track opt) {
      <div class="result-options shrink-font">
        <input type="radio" name="display" [(ngModel)]="componentData.config.display" [value]="opt.id" /> {{opt.value}} @if (opt.value === 'Hide') {
        <span>(Displays in Context)</span>
      }
    </div>
  }
</div>
</div>
<div>
  @switch (componentData.config.display) {
    @case ('text') {
      <div class="grid-x">
        <div class="cell small-2 shrink-font text-align-center">
          Prefix text:
        </div>
        <div class="cell small-4">
          <input type="text" [(ngModel)]="componentData.config.prefixText" />
        </div>
        <div class="cell small-2 shrink-font text-align-center">
          Suffix text:
        </div>
        <div class="cell small-4">
          <input type="text" [(ngModel)]="componentData.config.suffixText" />
        </div>
        <div class="cell small-12 shrink-font">
          Data will display as: {{ componentData.config.prefixText || "" }} (query result) {{ componentData.config.suffixText || "" }}
        </div>
      </div>
    }
    @case ('selectable') {
      <div class="grid-x">
        <div class="cell small-5 shrink-font">
          <input type="radio" name="limitSelection" [(ngModel)]="componentData.config.limitSelections" value="false" /> Do Not Limit Selections
        </div>
        <div class="cell small-4 shrink-font">
          <input type="radio" name="limitSelection" [(ngModel)]="componentData.config.limitSelections" value="true" /> Limit Selection to:
        </div>
        <div class="cell small-3">
          <input type="text" [(ngModel)]="componentData.config.maxSelections" [disabled]="disableLimitBox"/>
        </div>
      </div>
    }
  }
</div>
<div class="grid-x">
  <div class="cell shrink-font bold">
    @if (componentData.config.display === 'selectable') {
      <span>Selected</span>
    } @else {
      Query
    }
    results will @if (componentData.config.display === 'hide') {
    <span>only </span>
    }be stored in the data context:
  </div>
  <div class="cell shrink-font">
    {{dataContext}}
  </div>
</div>